import * as PIXI from 'pixi.js'
import { labelTypesWebGL } from '@/config'
import { clear } from '../utils'

export default function Label(layerInfo, options, container) {
  clear(container)
  container.zIndex = 1
  // TODO: 代码优化
  const data = layerInfo.data
  if (!data) return
  data.forEach(label => {
    const config = labelTypesWebGL[label.type]
    let graphic = new PIXI.Graphics()
    let text = new PIXI.Text()

    const style = label.active
      ? Object.assign({}, config.style.default, config.style.active)
      : config.style.default

    const startX = label.area[0] * options.width
    const startY = label.area[1] * options.height
    const endX = label.area[2] * options.width
    const endY = label.area[3] * options.height
    text.style = {
      fontFamily: 'Arial',
      fontSize: 18,
      fill: 'white',
      stroke: style.strokeStyle[0],
      strokeThickness: 2,
    }
    text.text = config.title

    switch (config.shape) {
      case 'rect':
        graphic.lineStyle(
          style.lineWidth,
          style.strokeStyle[0],
          style.strokeStyle[1],
        )
        graphic.beginFill(style.fillStyle[0], style.fillStyle[1])
        graphic.drawRect(
          startX,
          startY,
          label.area[2] * options.width - startX,
          label.area[3] * options.height - startY,
        )
        graphic.endFill()
        text.x = (startX < endX ? startX : endX) - 30
        text.y = (startY < endY ? startY : endY) - 30
        break
      case 'line':
        graphic.lineStyle(
          style.lineWidth,
          style.strokeStyle[0],
          style.strokeStyle[1],
        )
        graphic.moveTo(startX, startY)
        graphic.lineTo(
          label.area[2] * options.width,
          label.area[3] * options.height,
        )
        text.x = (startY < endY ? startX : endX) - 30
        text.y = (startY < endY ? startY : endY) - 30
        break
    }
    container.addChild(graphic)
    container.addChild(text)
  })
  return container
}
